<template>
  <div class="addQuestion" v-loading="loading">
    <div v-if="course && resourcesFrom == 1" class="addQuestion_head">
      <span v-if="showUpload" style="padding-right: 20px">
        <span class="zl_button zl_blueButton" @click="createQuestionBtn">创建试题</span>
        <span class="zl_button zl_blueButton" @click="addQues">添加试题</span>
      </span>
      <span style="font-weight:400;line-height: 28px;margin-right: 20px;" v-if="checkout">
        已选择{{isShort?selectResourse.length:checkList.length}}道实操题
      </span>
      <span style="display: flex;justify-content: flex-start;">
        <el-select
          v-model="categoryId"
          placeholder="全部分类"
          clearable
          size="mini"
          style="width: 147px;margin-right:8px;"
          @clear="initPageTotal"
          @change="postGetQuestionByCourseId"
        >
          <el-option
            v-for="item in resourceDatas"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-cascader
          v-if="courseModel != 1"
          size="mini"
          style="width: 200px;margin-right: 8px;"
          ref="cascader"
          placeholder="资源库分类"
          :options="cascaderOptions"
          v-model="materialsId"
          :props="{checkStrictly: true, label:'name', value: 'id'}"
          filterable
          clearable
          show-all-levels
          @change="postGetQuestionByCourseId"
        ></el-cascader>
        <el-input
          @keyup.enter.native="postGetQuestionByCourseId"
          style="width: 190px;"
          clearable
          v-model="name"
          size="mini"
          placeholder="请输入试题名称"
          @clear="initPageTotal"
          suffix-icon="el-icon-search"
        ></el-input>
      </span>
    </div>
    <div v-else class="addQuestion_head">
      <!--      <el-select-->
      <!--        size="mini"-->
      <!--        class="search_item"-->
      <!--        v-model="conditionList.purpose"-->
      <!--        @change="getQuestionList"-->
      <!--        placeholder="请选择用途"-->
      <!--        clearable-->
      <!--      >-->
      <!--        <el-option-->
      <!--          v-for="(item, i) in conditionList.purposeList"-->
      <!--          :key="i"-->
      <!--          :label="item.labelName"-->
      <!--          :value="item.id"-->
      <!--        ></el-option>-->
      <!--      </el-select>-->
      <!--      <el-select-->
      <!--        size="mini"-->
      <!--        class="search_item"-->
      <!--        v-model="conditionList.questionType"-->
      <!--        @change="getQuestionList"-->
      <!--        placeholder="请选择题型"-->
      <!--        clearable-->
      <!--      >-->
      <!--        <el-option-->
      <!--          v-for="(item, i) in conditionList.questionTypeList"-->
      <!--          :key="i"-->
      <!--          :label="item.questiontypeName"-->
      <!--          :value="item.id"-->
      <!--        ></el-option>-->
      <!--      </el-select>-->
      <el-select
        size="mini"
        class="search_item"
        v-model="conditionList.difficulty"
        @change="getQuestionList"
        placeholder="请选择难度"
        clearable
      >
        <el-option
          v-for="(item, i) in conditionList.difficultyList"
          :key="i"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        size="mini"
        class="search_item"
        v-model="conditionList.company"
        @change="getQuestionList"
        placeholder="请选择公司"
        clearable
      >
        <el-option
          v-for="(item, i) in conditionList.companyList"
          :key="i"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        size="mini"
        class="search_item"
        v-model="conditionList.tag"
        @change="getQuestionList"
        placeholder="请选择标签"
        clearable
      >
        <el-option
          v-for="(item, i) in conditionList.tagList"
          :key="i"
          :label="item.labelName"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        size="mini"
        style="width: 250px"
        v-model="conditionList.question"
        @keyup.enter.native="getQuestionList"
        placeholder="请输入标题或题干"
        clearable
      ></el-input>
      <el-button size="mini" type="primary" plain @click="getQuestionList()">查询</el-button>
    </div>
    <div style="flex: 1;position: relative">
      <el-table
        :data="questionList"
        ref="cTable"
        @row-click="rowClick"
        :width="`100%`"
        :height="`calc(100% - 80px)`"
        :cell-style="{ textAlign: 'left' }"
        :header-cell-style="{ textAlign: 'left' }"
        @selection-change="selectChange"
        @select="selectExit"
        @select-all="selectExit"
      >
        <el-table-column v-if="checkout" type="selection" width="55"></el-table-column>
        <el-table-column v-else label width="55">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="currentValue">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="taskName" label="标题">
          <template slot-scope="scope">
            <template v-if="scope.row.taskName && scope.row.taskName!=''">{{ scope.row.taskName}}</template>
            <template v-else>
              <template
                v-if="scope.row.questionContent && $delHtmlTag.delHtmlTag(scope.row.questionContent).substring(0,100).length>=100">
                {{scope.row.questionContent ? $delHtmlTag.delHtmlTag(scope.row.questionContent).substring(0,100) + '...'
                : ""}}
              </template>
              <template v-else>
                {{scope.row.questionContent ? $delHtmlTag.delHtmlTag(scope.row.questionContent).substring(0,100) : ""}}
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="questionAnswer" label="环境" v-if="environment">
          <template slot-scope="scope">
            <template v-if="scope.row.questionAnswer && scope.row.questionAnswer!=''">{{ scope.row.questionAnswer | handleAnswer}}</template>
          </template>
        </el-table-column>
        <el-table-column prop="questionTypeName" label="题型" width="120"></el-table-column>
        <el-table-column prop="difficulty" label="难度" width="120">
          <template
            slot-scope="scope"
          >{{ scope.row.difficulty == 1 ? '简单' : scope.row.difficulty == 2 ? '中等' : scope.row.difficulty == 3 ? '困难' :
            '' }}
          </template>
        </el-table-column>
        <el-table-column prop="score" label="建议分数" width="120"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">


            <el-button
              size="mini"
              type="text"
              style="color: #1890FF;"
              @click.native.prevent="showRow(scope.row,scope.$index)"
            >
              预览
            </el-button>
            <el-button
              v-if="scope.row.internalTypeId == 9 && courseModel != 1"
              size="mini"
              type="text"
              style="color: #1890FF;"
              @click.native.prevent="handleGoResource(scope.row,scope.$index)"
            >
              编辑
            </el-button>
<!--            <el-button-->
<!--              size="mini"-->
<!--              type="text"-->
<!--              style="color: #1890FF;"-->
<!--              @click.native.prevent="deleteBtn(scope.row,scope.$index)"-->
<!--            >-->
<!--              删除-->
<!--            </el-button>-->
          </template>
        </el-table-column>
        <div slot="empty" class="empty_material">
          <p>暂无试题</p>
        </div>
      </el-table>
      <div class="pagination_class">
        <Pagination
          :currentpage="pageTotal.currentPage"
          :limit="pageTotal.pageSize"
          :total="pageTotal.total"
          layout="sizes, prev, pager, next, jumper"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :small="true"
        ></Pagination>
      </div>
    </div>
    <!-- 弹窗 -->
    <n-dialog
      :title="'提示'"
      :dialogVisible="addTestPaperShow"
      :width="'400px'"
      :dialogType="dialogType"
      :deleteNum="'1'"
      :deleteName="deleteName"
      :isDedicated="isDedicated"
      @conformFunc="conformFunc"
      @closeDialog="closeDialog"
    ></n-dialog>

    <!-- 创建实操题 -->
    <el-drawer
      :visible.sync="createQuestionShow"
      :direction="direction"
      size="80%"
      :with-header="false"
      :close-on-press-escape="false"
      :before-close="closeCreateQuestion">
      <createQuestion
        ref="createQuestion"
        :courseId="courseId"
        :isShowResourceClassify="isShowResourceClassify"
        @closeCreateQuestion="closeCreateQuestion"
        @saveQuestion="saveQuestion">
      </createQuestion>
    </el-drawer>
    <n-dialog
      :isField="isField"
      :subjectId="subjectId"
      :title="dialogTitle"
      :dialogVisible="addQuestionShow"
      :width="dialogWidth"
      :courseId="courseId"
      :questionId="questionId"
      :dialogType="dialogType"
      @closeDialog="closeDialog1"></n-dialog>
  </div>
</template>

<script>
  import * as api from "../../api/courseApi";
  import * as sourceApi from "../../api/sourceApi";
  import * as creatingPracticalTrainingApi from "../../api/creatingPracticalTrainingApi.js";
  import Pagination from "@/components/paginator/paginator";
  import questDialog from "../szrt_revision/new_course_module/editCourse/question"
  import createQuestion from '../../components/views/course/components/createQuestion.vue'

  export default {
    name: "addQuestion.vue",
    props: {
      value: {
        type: [String, Number],
        default: "",
      },
      subjectId: {
        type: [String, Number],
        default: 0,
      },
      courseId: {
        type: [String, Number],
        default: 0,
      },
      resourcesFrom: {
        type: String,
        default: '',
      },
      course: {
        type: Boolean,
        default: false,
      },
      isShort: {
        type: Boolean,
        default: false,
      },
      checkout: {
        type: Boolean,
        default: false,
      },
      showUpload: {
        type: Boolean,
        default: false,
      },
      checkList: {
        type: Array,
        default: () => [],
      },
      selectResourse: {
        type: Array,
        default: () => [],
      },
      qsType: {  // 0 查全部 ,1 查除单多判所有试题 ,2 只查询实操题,3 查除组合和简答所有试题
        type: [Number, String],
        default: 0
      },
      isField: {
        type: Boolean,
        default: false,
      },
      environment: { // 是否显示 ‘环境’ (课程-编辑-添加内容-实操题)
        type: Boolean,
        default: false,
      },
    },
    components: {
      Pagination,
      questDialog,
      createQuestion
    },
    data() {
      return {
        currentValue: this.value,
        currentValueList:'',
        materialId: null,
        addQuestionShow: false,
        dialogWidth: '800px',
        conditionList: {
          //素材名称
          subject: null, //所选科目
          subjectName: "",
          subjectList: [], //科目列表
          questionType: null,
          questionTypeIds: [], // 实操ids
          questionTypeList: [],
          purpose: null, //所选用途
          purposeList: [], //用途列表
          difficulty: null, //所选难度
          difficultyList: [
            {value: "1", label: "简单"},
            {value: "2", label: "中等"},
            {value: "3", label: "困难"},
          ], //难度列表
          company: null, //所选公司
          companyList: [], //公司列表
          tag: null, //所选标签
          tagList: [], //标签列表
          question: "",
        },
        questionList: [],

        pageTotal: {
          //分页
          currentPage: 1,
          pageSize: 10,
          total: 10,
        },
        name: "",
        resourceDatas: [],
        categoryId: "",
        questionId: '',
        cascaderOptions: [],
        materialsId: '',  // 知识点
        isPaging: false,
        productFlag: sessionStorage.getItem("productFlag"),
        // 删除弹窗
        dialogTitle: "",
        dialogType: "",
        deleteName: "",
        deleteDialog: {
          categoryResourceId: "",
          resourceId: "",
        },
        addTestPaperShow: false,
        isDedicated: true,
        // 创建实操题
        createQuestionShow: false,
        direction: 'rtl',
        isCreate: true,//防止连续创建试题
        isShowResourceClassify: true,
        //
        loading: false,
        courseModel: '', // 产品模式 1标准 2产品
        courseProfessional: '',
        query: {},
      };
    },
    watch: {
      value(val) {
        this.currentValue = val;
      },
      currentValue(val) {
        this.$emit("input", val);
      },
      resourcesFrom() {
        this.pageTotal = {
          currentPage: 1,
          pageSize: 10,
          total: 10,
        }
        this.init();
      },
      checkList: {
        handler(val) {
          // console.log(val)
          if (val.length > 0) {
            setTimeout(() => {
              val.forEach((val, ind) => {
                this.$refs.cTable.toggleRowSelection(val, true);
              })
            }, 300)
          }
        },
        deep: true,
        immediate: true,
      }
    },
    computed: {},
    created() {
      if (this.$route.query.query) {
        this.query = JSON.parse(this.$AES.AES_Decrypt(this.$route.query.query))
      } else {
        this.query = this.$route.query
      }
      this.courseModel = this.query.courseModel
      this.init();
    },
    mounted() {
    },
    filters: {
      handleAnswer(val) {
        // let nickNames = ['防火墙虚拟平台','jupyter','代码块','远程桌面','网络安全模拟器','代码填空题']
        let ary = []
        try {
          // val:'正确' 这种情况会报错
          ary = JSON.parse(val);
        } catch (error) {
          
        }
        // console.log(ary,"ary")
        let str1 = '', str2 = '';
        // for (let item of ary) {
        //   if (item.eventName.includes('数据预制')) {
        //     str2 = "答案上传"
        //   } else {
        //    !str1 && nickNames.forEach(nickname => {
        //       if (item.eventName.includes(nickname)) {
        //         str1 = nickname
        //       }
        //     })
        //   }
        //   if (str1 && str2) {
        //     break
        //   }
        // }
        for (let item of ary) {
          if (item.alias) {
            if (item.alias.includes('答案上传')) {
              str2 = item.alias
            } else {
              str1 = str1 || item.alias
            }
          }
          if (str1 && str2) {
            break
          }
        }
        return (str1 && str2) ? str1 + '，' + str2 : (str1 || str2)
      }
    },
    methods: {
      init() {
        // this.loading = true;
        this.questionList = [];
        if (this.course && this.resourcesFrom == '1') {
          this.findResCategoryByCourseId();
          this.postGetQuestionByCourseId();
          this.getMaterialTreeListById(); // 知识点
        } else {

          this.getQuestionPurpose(); //获取用途
          this.queryCompany(); //获取公司

        }
        this.getCourseInfo();
      },
      getCourseInfo(){//获取课程信息
        api.getCourseInfo(this.courseId).then((rs)=>{
          if(rs.code==0){
            this.courseProfessional = rs.data.courseProfessional
          }else{
            this.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      //添加试题
      addQues() {
        let type = -1;
        // if (this.type > -1) {
        //   type = this.type == 7 ? 7 : 4;
        // } else if (this.addType > -1) {
        //   type = this.addType;
        // }
        this.$emit('addQues', type)
      },
      postGetQuestionByCourseId() {

        let materialsId = '';
        if (this.materialsId.length) {
          materialsId = this.materialsId[this.materialsId.length - 1]
        }
        let params = {
          courseId: this.courseId, //课程id
          categoryId: this.categoryId, //资源分类id
          name: this.name, //试题名称
          pageNum: this.pageTotal.currentPage,
          pageSize: this.pageTotal.pageSize,
          isSelectAll: this.qsType,    //   0 查全部 ,1 查除单多判所有试题 ,2 只查询实操题,3 查除组合和简答所有试题
          // materialsId: materialsId,
          materialIds: materialsId ? [materialsId] : [],
          resourceType: 3, // 资源类型(1:ppt,2:文件,3:试题,4:视频,5:试卷,6:共享资源，7素材（查询：视频、ppt、文件）) api.getSourceList 接口用
        };
        // api.postGetQuestionByCourseId(params).then((res) => {
        api.getSourceList(params).then((res) => { 
          if (res.code == 0) {
            this.questionList = res.data.list;
            this.pageTotal.total = res.data.total;
            if (this.isShort) {
              this.$parent.presentList = this.$parent.getQuestionList(this.questionList, '交集')
            }
            this.isPaging = false
          }
        }).finally(() => {
          this.loading = false;
        })
      },
      getMaterialTreeListById() {
        this.cascaderOptions = [];
        if (!this.subjectId) {
          return
        }
        sourceApi.getMaterialTreeListById(this.subjectId).then((res) => {
          if (res.code == 0) {
            this.cascaderOptions = this.getTreeData(res.data.materials);
          }
        });
      },
      /**
       * 解决el-cascader控件 最后一级暂无数据仍然显示。
       * @param data
       * @returns {Array}
       */
      getTreeData(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children.length < 1) {
            // child若为空数组，则将child设为undefined
            data[i].children = undefined;
          } else {
            // child若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].children);
          }
        }
        return data;
      },
      // 查询资源分类
      findResCategoryByCourseId() {
        sourceApi
          .FindResCategoryByCourseId(this.courseId)
          .then((res) => {
            if (res.code == "0") {
              this.resourceDatas = res.data;
              // if (res.data.length) this.categoryId = res.data[0].id
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      // 试题
      getQuestionList() {
        this.questionList = [];
        let tagArr = null;
        if (this.conditionList.tag) {
          let tagObj = {
            id: this.conditionList.tag,
          };
          tagArr = [tagObj];
        } else {
          tagArr = null;
        }
        let obj = {
          beginTime: null, //开始时间
          endTime: null, //结束时间
          companyId: this.conditionList.company, //公司id
          difficulty: this.conditionList.difficulty, //难度
          labelId: this.conditionList.purpose, //用途
          materialIds: this.materialId ? [this.materialId] : null, //目录id集合
          pageNo: this.pageTotal.currentPage, //当前页
          pageSize: this.pageTotal.pageSize, //每页个数
          personLabels: tagArr, //标签
          questionContent: this.conditionList.question, //试题内容
          // questionTypeId: this.conditionList.questionType, //题型id
          questionTypeIds: this.conditionList.questionTypeIds, //题型id
          subjectId: this.subjectId, //科目id
        };
        api
          .queryQuestionList(obj)
          .then((res) => {
            if (res.code == 0) {
              this.questionList = res.data.list;
              this.pageTotal.total = res.data.totalCount;
            } else {
              this.$messageError(res.msg);
            }
          }).finally(() => {
          this.loading = false;
        })
          .catch((e) => {
          });
      },
      handleCurrentChange(val) {
        this.pageTotal.currentPage = val || this.pageTotal.currentPage;
        if (this.course  && this.resourcesFrom == 1) {
          this.postGetQuestionByCourseId();
        } else {
          this.getQuestionList();
        }
      },
      handleSizeChange(val) {
        this.pageTotal.pageSize = val;
        this.pageTotal.currentPage = 1;
        if (this.course  && this.resourcesFrom == 1) {
          this.postGetQuestionByCourseId();
        } else {
          this.getQuestionList();
        }
      },
      // 选择知识点，查询素材
      knowledgePointsNodeClick(knowledgePoints) {
        this.materialId = knowledgePoints.id;
        this.getQuestionList();
      },
      getQuestionType(id) {
        //获取试题类型
        api
          .getQuestionType(id)
          .then((rs) => {
            if (rs.code == 0) {
              // that.conditionList.questionTypeList = rs.data;
              this.conditionList.questionTypeIds = [];
              [].forEach.call(rs.data, item => {
                if (item.internaltypeid == 9) {
                  // this.conditionList.questionType = item.id;
                  this.conditionList.questionTypeIds.push(item.id);
                }
              })
              this.getQuestionList();
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      // wjl  实操题编辑，跳到资源库去
      handleGoResource(item) {
        if (item.internalTypeId == 9) {
          // this.iframeShow = true;
          creatingPracticalTrainingApi.getQuestionDetail(item.id).then(res => {
            if (res.code == 0) {
              let token = localStorage.getItem('Authorization')
              window.open(process.env.RESOURSE_URL + '/#/?type=gxzx&token=' + token + "&id=" + item.id + "&labelId=" + res.data.labels[0].id + "&companyId=" + res.data.questions.companyId + "&subjectId=" + res.data.questions.subjectId + '&professional=' + this.courseProfessional)
            }
          })
        }
        // else if(item.resourceType == 5){
        //   this.$router.push({
        //     path:'/addTest',
        //     query: {
        //       paperId: item.id,
        //       courseId: this.$route.query.id,
        //       subjectId: this.$route.query.subjectId,
        //       courseName: this.$route.query.courseName,
        //       catalogId: this.$store.state.catalogId,
        //       subjectName: this.$route.query.subjectName
        //     }
        //   })
        // }
      },
      showRow(row, index) {
        this.questionId = row.id
        this.dialogType = 'questionPreview'
        this.dialogTitle = '试题预览'
        this.addQuestionShow = true
      },
      getQuestionPurpose() {
        //获取用途和标签
        api
          .getQuestionPurpose()
          .then((rs) => {
            if (rs.code == 0) {
              this.conditionList.purposeList = rs.data;
              this.conditionList.purpose = null;
              // 用途 传空
              // rs.data.forEach((v) => {
              //   if (v.labelName == "书证融通" && this.productFlag == 1) {
              //     this.conditionList.purpose = v.id;
              //   }
              //   // if (v.labelName == "单项训练" && this.productFlag == 2) {
              //   //   this.conditionList.purpose = v.id;
              //   // }
              //   // if (v.labelName == "综合实训" && this.productFlag == 3) {
              //   //   this.conditionList.purpose = v.id;
              //   // }
              //   // if (v.labelName == "真实任务" && this.productFlag == 4) {
              //   //   this.conditionList.purpose = v.id;
              //   // }

              // });
              this.getQuestionType(this.subjectId); //获取题型
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
        api
          .getQuestionPurpose({lableType: 1})
          .then((rs) => {
            if (rs.code == 0) {
              this.conditionList.tagList = rs.data;
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      queryCompany() {
        //获取公司
        let that = this;
        let obj = {
          subjectId: this.subjectId,
        };
        api
          .queryCompany(obj)
          .then((rs) => {
            if (rs.code == 0) {
              that.conditionList.companyList = rs.data;
            } else {
              that.$messageError(rs.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      rowClick(row) {
        this.currentValue = row.id;
        this.$emit('hhdTeacher', row);
      },
      closeDialog1() {
        this.addQuestionShow = false;
      },
      selectChange(data) {
        this.$emit("selectChange", data);
      },
      selectExit(data) {
        if (this.checkList.length > data.length) {
          let arr = data;
          let arr01 = this.checkList;
          let arr02 = [...arr01].filter(x => [...arr].every(y => y !== x));
          this.$emit('removeCheck', arr02, this.pageTotal.currentPage)
          // console.log('jian',arr02,this.pageTotal.currentPage)
        } else {
          // console.log('jia')
        }
        // console.log(data,'selectExit')
      },
      formatCreateTime(item) {
        if (!item || !item.createTime) return "";
        var date = new Date(item.createTime);
        var fmt = "yyyy-MM-dd";
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
        return fmt;
      },
      initPageTotal() {
        this.$set(this.pageTotal, "currentPage", 1);
      },
      //重置勾选数据
      initCheckList(obj) {
        let checkObj = {}
        this.questionList.forEach((val, ind) => {
          if (val.id == obj.id) {
            checkObj = val
          }
        })
        this.$refs.cTable.toggleRowSelection(checkObj, false);
      },

      // 删除
      deleteBtn(row) {
        // console.log(row);
        // this.deleteName = '<div class="question_title">'+row.taskName+'</div>'
        this.deleteDialog.categoryResourceId = row.categoryResourceId;
        this.deleteDialog.resourceId = row.id;
        this.dialogWidth = "400px";
        this.dialogType = "deleteQuestion";
        this.addTestPaperShow = true;
      },
      closeDialog() {
        this.addTestPaperShow = false;
        // this.findPageResource();
      },
      conformFunc() {
        let params = {
          courseId: this.courseId, //课程id
          resourceId: this.deleteDialog.resourceId, // id
          categoryResourceId: this.deleteDialog.categoryResourceId
        };
        api.deleteFromCatalog(params).then(res => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            // 删除内容时。清除选中的内容
            if (this.currentValue == this.deleteDialog.resourceId) this.currentValue = '';   // 删除内容时，清空选中项
            this.$emit("selectChange", []);
            this.closeDialog();
            this.postGetQuestionByCourseId();
          } else {
            this.$message.error(res.msg);
          }
        })
      },

      // 创建实操题
      closeCreateQuestion() {//创建实操题关闭
        this.createQuestionShow = false;
      },
      createQuestionBtn() {//创建实操题
        api.FindTypeBySubject({
          subjectId: this.subjectId,
        }).then(res => {
          if (res.code === "0") {
            if (res.data.length > 0) {
              let arr = []
              res.data.forEach(v => {
                if (v.internaltypeid == 9) {
                  arr.push(v)
                }
              })
              if (arr.length > 0) {
                this.createQuestionShow = true;
                if (this.$refs.createQuestion) {
                  this.$refs.createQuestion.$refs.ruleForm.resetFields()
                }
              } else {
                this.$messageWarning('该课程所属科目下暂无实操题题型，请先去“题型管理”添加相关题型！')
              }
            } else {
              this.$messageWarning('该课程所属科目下暂无题型，请先去“题型管理”添加题型！')
            }
          } else {
            this.$messageError(res.msg)
          }
        })
      },
      saveQuestion(obj, flag) { //保存实操题
        // console.log(obj,flag);
        if (!this.isCreate) return
        let that = this
        this.isCreate = false;
        obj.categoryId = obj.resourceCategoryId;
        obj.courseId = that.courseId;
        obj.catalogId = that.$parent.catalogue.id;
        api.createQuestiontData_new(obj).then(res => {
          if (res.code == 0) {
            // console.log(res.data);
            that.$messageSuccess(res.msg);
            if (flag == "next") {
              let token = localStorage.getItem('Authorization');
              window.open(
                process.env.RESOURSE_URL + '/#/?type=gxzx&token=' + token +
                "&id=" + res.data +
                "&labelId=" + obj[0] +
                "&companyId=" + obj.companyId +
                "&subjectId=" + obj.subjectId +
                "&professional=" + this.courseProfessional
              )
            } else {
              that.closeCreateQuestion();
              that.postGetQuestionByCourseId();
            }
          } else {
            that.$messageError(res.msg)
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.isCreate = true;
        })


        // api.createQuestiontData(obj).then(rs=>{
        //   if(rs.code==0){
        //     let questionId = rs.data
        //     let Material = {
        //       catalogId: that.$parent.catalogue.id,
        //       // catalogId: that.catalogInfo.id,
        //       courseId: that.courseId,
        //       list: [
        //         {
        //           catalogId: that.$parent.catalogue.id,
        //           courseId: that.courseId,
        //           resourceId: rs.data,
        //           type: 3,
        //         }
        //       ]
        //     }
        //     api.submitMaterialBtn(Material).then(res=>{
        //       if(res.code==0){
        //         that.$messageSuccess('添加成功')
        //         if(flag=='back'){
        //           that.createQuestionShow = false
        //           that.handleNodeClick(this.selectTreeData)
        //         }else{
        //           that.createQuestionShow = false
        //           that.handleNodeClick(this.selectTreeData)
        //           // that.iframeShow = true;
        //           api.QueryTestData({
        //             id: parseInt(questionId),
        //             parentId: 0,
        //           }).then(result =>{
        //             if(result.code == 0 ){
        //               let token = localStorage.getItem('Authorization')
        //               window.open(process.env.RESOURSE_URL + '/#/?type=gxzx&token='+token+"&id="+questionId+"&labelId="+result.data.list[0].labels[0].id+"&companyId="+result.data.list[0].companyId+"&subjectId="+result.data.list[0].subjectId)
        //             }
        //           })
        //         }
        //       }else{
        //         that.$messageError(res.msg)
        //       }
        //     })
        //   }else{
        //     that.$messageError(rs.msg)
        //   }
        //   this.isCreate = true
        // })
      },
    },
  };
</script>

<style scoped lang="scss">
  .addQuestion {
    height: 100%;
    width: 100%;
    color: #2b2a33;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .addQuestion_head {
      /*line-height: 35px;*/
      display: flex;
      justify-content: flex-end;
      padding: 15px 0;

      .search_item {
        width: 150px;
      }
    }
  }

  .icon-add {
    width: 14px;
    height: 14px;
    /*background:red;*/
  }

  /deep/ .has-gutter .cell {
    font-size: 12px;
    color: #767484;
    font-weight: 600;
  }

  .btn_wrap {
    display: block;
    height: 60px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .pagination_class {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
<style>
  .el-cascader-menu {
    width: 255px;
  }
</style>



// WEBPACK FOOTER //
// src/views/component/addQuestion.vue